const requireComponent = require.context('./', true, /^\.\/generalBlocks(\/.+)*\/main\.js$/);

requireComponent.keys().forEach(requireComponent);
